import { createFileRoute } from '@tanstack/react-router';

import { SellEntryPage } from '@/features/land/sell-entry-page';

export const Route = createFileRoute('/_app/land/sell/')({ component: SellEntryPage });
